module.exports = __webpack_public_path__ + "static/img/m_download_dashed2@3x.93c8814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_download_dashed2@3x.png
// module id = QdpA
// module chunks = 1